import React from "react";

// components

import CardPicture from "components/Cards/CardPicture.js";

export default function Picture() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-8/12 px-4">
          <CardPicture />
        </div>
      </div>
    </>
  );
}
